import { render, staticRenderFns } from "./BaseBottomButton.vue?vue&type=template&id=9fd96b5c&scoped=true&"
import script from "./BaseBottomButton.vue?vue&type=script&lang=ts&"
export * from "./BaseBottomButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBottomButton.vue?vue&type=style&index=0&id=9fd96b5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd96b5c",
  null
  
)

export default component.exports